export function unreachable(param: never) {
  return new Error(`Unreachable case with value ${JSON.stringify(param)}`);
}

type Subunion<T extends { type: string }, U extends T['type']> = T extends unknown
  ? T['type'] extends U
    ? T
    : never
  : never;
type UnionFromTuple<U extends readonly unknown[]> = U[number];

type IsOfType = {
  <T extends { type: string }, U extends readonly T['type'][]>(types: U, item: T): item is Subunion<
    T,
    UnionFromTuple<U>
  >;
  <T extends { type: string }, U extends T['type']>(type: U, item: T): item is Subunion<T, U>;
  // curried versions (works in functions like 'filter')
  <T extends { type: string }, U extends readonly T['type'][]>(tags: U): (
    item: T
  ) => item is Subunion<T, UnionFromTuple<U>>;
  <T extends { type: string }, U extends T['type']>(tag: U): (item: T) => item is Subunion<T, U>;
};

// General type utility function to narrow down discriminated union types
export const isOfType: IsOfType = ((tagOrTags: any, maybeItem: any): any => {
  const tags = Array.isArray(tagOrTags) ? tagOrTags : [tagOrTags];
  if (maybeItem) {
    return tags.includes(maybeItem.type);
  } else {
    return (item: any) => tags.includes(item.type);
  }
}) as any;
